import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=c07e1df4"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=c07e1df4&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c07e1df4')) {
      api.createRecord('c07e1df4', component.options)
    } else {
      api.reload('c07e1df4', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=c07e1df4", function () {
      api.rerender('c07e1df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/main/src/page/chatPage/content/chat/drawer/UserList.vue"
export default component.exports